export const getProofOfCoverageDetails = /* GraphQL */ `
  mutation GetProofOfCoverageDetails(
    $policyLocator: String!
    $residentId: ID!
  ) {
    getCtCoverageDetails(
      policyLocator: $policyLocator
      residentId: $residentId
    ) {
      status
      addressMissmatch
      policyUnitAddress
      residentSiteAddress
      coverage {
        id
        agencyName
        agencyAddress
        agencyPhoneNumber
        agencyEmail
        insuranceCarrierName
        isActive
        coverageDetails {
          occupancy
          homeType
          manufacturer
          modelYear
          animalLiabilityLimit
          homeCoverageLimit
          otherStructuresLimit
          personalLiabilityLimit
          personalPropertyLimit
          residentLiabilityLimit
          standardDeductibleLimit
          medicalPaymentsLimit
        }
        policyType
        policyId
        policyDescription
        policyStatus
        policyEffectiveDate
        policyEndDate
        annualCost
      }
    }
  }
`;
